<template>
  <div class="home">
    <Header />    
    <div>Wrong URL</div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import  "../../node_modules/bootstrap/scss/bootstrap.scss";
import Header from "@/components/Layout/HeaderLayout";
import Footer from "@/components/Layout/Footer";

export default {
  name: 'Http404',
  components: {
    Header,
    Footer
  }
}
</script>
